import { all, put, call, takeLatest } from 'redux-saga/effects';

import Cookie from 'react-cookies'
import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

export default function* fetchLogin() {

	yield all([
		takeLatest(actions.FETCH_CHECKIP_REQUEST, checkIP),
		takeLatest(actions.FETCH_LOGIN_REQUEST, login),
		takeLatest(actions.FETCH_LOGOUT_REQUEST, logout)
	])
}

function* checkIP() {
	try {
		const result = yield call(api.checkIP);

		yield put({
			type: actions.FETCH_CHECKIP_SUCCESS,
			checkIP: result.data.checkIP,
			remoteAddr: result.data.remoteAddr
		})
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* login(param) {
	try {
		const result = yield call(api.authLogin,param)

		if (result.data.resultCode > 0) {
			yield put({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				message: "message.box.login.failed",
				isError: true
			})
		} else {
			yield put({
				type: actions.FETCH_LOGIN_SUCCESS
			})
		}
	}
	catch (error) {
		yield put({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* logout() {
	try {		
		for (var cookName in Cookie.loadAll()) {
			if (cookName==="se_session") Cookie.remove("se_session",{path:"/"})
		}
	
		yield put({
			type: actions.FETCH_LOGOUT_SUCCESS,
		})
	}
	catch (error) {
	}
	finally {
		yield put({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}
